var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 14,
    viewBox: "0 0 22 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 7C0 6.79375 0.0827751 6.59595 0.230116 6.45011C0.377456 6.30426 0.577293 6.22233 0.785664 6.22233H19.3163L14.3714 1.32924C14.2238 1.18322 14.141 0.985162 14.141 0.778651C14.141 0.57214 14.2238 0.374087 14.3714 0.228061C14.5189 0.082036 14.719 4.86557e-09 14.9276 0C15.1363 -4.86557e-09 15.3363 0.082036 15.4839 0.228061L21.7692 6.44941C21.8423 6.52165 21.9004 6.60747 21.94 6.70195C21.9796 6.79642 22 6.89771 22 7C22 7.10229 21.9796 7.20357 21.94 7.29805C21.9004 7.39253 21.8423 7.47835 21.7692 7.55059L15.4839 13.7719C15.3363 13.918 15.1363 14 14.9276 14C14.719 14 14.5189 13.918 14.3714 13.7719C14.2238 13.6259 14.141 13.4279 14.141 13.2213C14.141 13.0148 14.2238 12.8168 14.3714 12.6708L19.3163 7.77767H0.785664C0.577293 7.77767 0.377456 7.69574 0.230116 7.5499C0.0827751 7.40405 0 7.20625 0 7V7Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right_arrow.888243133dde7dab47b05605e0a39270.svg";
export { ForwardRef as ReactComponent };